import { User } from './user.model';
import { Showreport } from '../app/showreport/showreport.model';
import { TaskDTO } from './taskDTO.model';
import { Priority } from './priority.model';
import { Show } from './show.model';
import { Image } from './image.model';
import { ImageAttachable } from './image-attachable';

export class Task implements ImageAttachable {
    createdAt?: string | null = null;
    updatedAt?: string | null = null;
    id?: number = 0;
    title: string = '';
    description?: string = '';
    completedDateTime?: string | null = null;
    submittedBy?: User | null = null;
    updatedBy?: User | null = null;
    completedBy?: User | null = null;
    show?: Show | null = null;
    showreport?: Showreport | null = null;
    completed?: boolean = false;
    priority?: Priority = Priority.Medium;
    imageIds?: number[] = [];
    images?: Image[] = [];
    removedImageIds?: number[] = [];
    comments: any[] = []; // TODO: Create comment class

    public static createFromJson(json: any): Task {
        const entity = new Task();
        entity.createdAt = json.createdAt;
        entity.updatedAt = json.updatedAt;
        entity.id = json.id;
        entity.title = json.title;
        entity.description = json.description;
        entity.completedDateTime = json.completedDateTime;
        entity.submittedBy = json.submittedBy;
        entity.updatedBy = json.updatedBy;
        entity.completedBy = json.completedBy;
        entity.show = json.show;
        entity.showreport = json.showreport;
        entity.completed = json.completed;
        entity.priority = json.priority;
        entity.imageIds = json.imageIds ?? [];
        entity.images = json.images?.map((imgJson => Image.createFromJson(imgJson))) ?? [];
        entity.removedImageIds = json.removedImageIds ?? [];
        entity.comments = json.comments ?? [];
        return entity;
    }

    public convertToDTO(): TaskDTO {
        const taskDTO = new TaskDTO();
        taskDTO.title = this.title?.trim();
        taskDTO.showId = this.show?.id ?? null;
        taskDTO.description = this.description?.trim() ?? null;
        taskDTO.submittedByUserId = this.submittedBy?.id ?? null;
        taskDTO.showreport = this.showreport?.id ?? null;
        taskDTO.priority = this.priority ?? Priority.Medium;
        taskDTO.imageIds = this.imageIds ?? [];
        taskDTO.removedImageIds = this.removedImageIds ?? [];
        return taskDTO;
    }

    public isNew(): boolean {
        return (this.id == null || this.id === 0);
    }

    // private convertPriorityNumberToString(priority: number): string {
    //     switch (priority) {
    //         case 1:
    //             return 'VERY_HIGH';
    //         case 2:
    //             return 'HIGH';
    //         case 3:
    //             return 'MEDIUM';
    //         case 4:
    //             return 'LOW';
    //         case 5:
    //             return 'VERY_LOW';
    //         default:
    //             return 'MEDIUM';
    //     }
    //
    // }

}
